const ReportIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83325 14.1667V10.8334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M10 14.1667V5.83337"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M14.1667 14.1666V9.16663"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M2.08325 10C2.08325 6.26809 2.08325 4.40212 3.24262 3.24274C4.40199 2.08337 6.26797 2.08337 9.99992 2.08337C13.7318 2.08337 15.5978 2.08337 16.7573 3.24274C17.9166 4.40212 17.9166 6.26809 17.9166 10C17.9166 13.732 17.9166 15.598 16.7573 16.7574C15.5978 17.9167 13.7318 17.9167 9.99992 17.9167C6.26797 17.9167 4.40199 17.9167 3.24262 16.7574C2.08325 15.598 2.08325 13.732 2.08325 10Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReportIcon;
